import { useCallback, useState } from 'react';
import { Mail } from 'lucide-react';
import { useApp } from '../context/AppContext';

const DISMISS_KEY = 'emailVerifyBannerDismissed';

/** Slim strip below the header nudging email/password users to verify and unlock credits. */
export function EmailVerifyBanner() {
  const { needsEmailVerification, openVerifyEmailModal } = useApp();
  const [dismissed, setDismissed] = useState(
    () => typeof window !== 'undefined' && sessionStorage.getItem(DISMISS_KEY) === '1',
  );

  const handleDismiss = useCallback(() => {
    sessionStorage.setItem(DISMISS_KEY, '1');
    setDismissed(true);
  }, []);

  if (!needsEmailVerification || dismissed) return null;

  return (
    <div
      role="region"
      aria-label="Email verification"
      data-testid="email-verify-banner"
      style={{
        background: 'linear-gradient(90deg, rgba(245, 158, 11, 0.12) 0%, rgba(245, 158, 11, 0.06) 50%, rgba(245, 158, 11, 0.12) 100%)',
        borderBottom: '1px solid rgba(245, 158, 11, 0.22)',
      }}
    >
      <div
        className="container"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 10,
          padding: '10px 24px',
          color: 'var(--warning)',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: 1.4,
          textAlign: 'center',
        }}
      >
        <Mail size={15} strokeWidth={2} aria-hidden style={{ flexShrink: 0, opacity: 0.9 }} />
        <span>Verify your email to unlock $2 in free agent credits.</span>
        <button
          type="button"
          data-testid="email-verify-banner-cta"
          onClick={() => openVerifyEmailModal({ autoSend: true })}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            margin: 0,
            color: 'inherit',
            font: 'inherit',
            fontWeight: 600,
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            cursor: 'pointer',
          }}
        >
          Verify email
        </button>
        <button
          type="button"
          aria-label="Dismiss"
          data-testid="email-verify-banner-dismiss"
          onClick={handleDismiss}
          style={{
            background: 'none',
            border: 'none',
            padding: '0 4px',
            marginLeft: 4,
            color: 'inherit',
            opacity: 0.7,
            cursor: 'pointer',
            fontSize: '16px',
            lineHeight: 1,
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default EmailVerifyBanner;
